
import { CFCDN } from "../../shop-front-component/ProductCollection";



export interface colourType {
    title: string;
    src: string;
}


export const VibeBlockout = [
    {
        title:'Alloy',
        src: CFCDN+"vibe-block-out/Alloy.jpg",
    },
    {
        title:'Birch',
        src: CFCDN+"vibe-block-out/Birch.jpg",
    },
    {
        title:'Bistro',
        src: CFCDN+"vibe-block-out/Bistro.jpg",
    },
    {
        title:'Brulee Metallic',
        src: CFCDN+"vibe-block-out/Brulee-Metallic.jpg",
    },
    {
        title:'Chateau',
        src: CFCDN+"vibe-block-out/Chateau.jpg",
    },
    {
        title:'Clay',
        src: CFCDN+"vibe-block-out/Clay.jpg",
    },
    {
        title:'Cloud',
        src: CFCDN+"vibe-block-out/Cloud.jpg",
    },
    {
        title:'Coal',
        src: CFCDN+"vibe-block-out/Coal.jpg",
    },
    {
        title:'Dune',
        src: CFCDN+"vibe-block-out/Dune.jpg",
    },
    {
        title:'Ice',
        src: CFCDN+"vibe-block-out/Ice.jpg",
    },
    {
        title:'Lace',
        src: CFCDN+"vibe-block-out/Lace.jpg",
    },
    {
        title:'Limestone',
        src: CFCDN+"vibe-block-out/Limestone.jpg",
    },
    {
        title:'Linen',
        src: CFCDN+"vibe-block-out/Linen.jpg",
    },
    {
        title:'Loft',
        src: CFCDN+"vibe-block-out/Loft.jpg",
    },
    {
        title:'Mercury Metallic',
        src: CFCDN+"vibe-block-out/Mercury Metallic.jpg",
    },
    {
        title:'Mist',
        src: CFCDN+"vibe-block-out/Mist.jpg",
    },
    {
        title:'Moon',
        src: CFCDN+"vibe-block-out/Moon.jpg",
    },
    {
        title:'Nimbus',
        src: CFCDN+"vibe-block-out/Nimbus.jpg",
    },
    {
        title:'Odessey',
        src: CFCDN+"vibe-block-out/Odessey.jpg",
    },
    {
        title:'Orient',
        src: CFCDN+"vibe-block-out/Orient.jpg",
    },
    {
        title:'Porcelain',
        src: CFCDN+"vibe-block-out/Porcelain.jpg",
    },
    {
        title:'Pure',
        src: CFCDN+"vibe-block-out/Pure.jpg",
    },
    {
        title:'Spirit',
        src: CFCDN+"vibe-block-out/Spirit.jpg",
    },
    {
        title:'Stone',
        src: CFCDN+"vibe-block-out/Stone.jpg",
    },
    {
        title:'Storm',
        src: CFCDN+"vibe-block-out/Storm.jpg",
    },
    {
        title:'Surf',
        src: CFCDN+"vibe-block-out/Surf.jpg",
    },
    {
        title:'Terrace',
        src: CFCDN+"vibe-block-out/Terrace.jpg",
    },
    {
        title:'Umber',
        src: CFCDN+"vibe-block-out/Umber.jpg",
    },
    {
        title:'Tundra',
        src: CFCDN+"vibe-block-out/Tundra.jpg",
    },
    {
        title:'Whisper',
        src: CFCDN+"vibe-block-out/Whisper.jpg",
    },
]

// Blockout Fabrics
const ChatswoodBlockout = [{title: "Aztec", src: CFCDN+"Chatswood-Block-Out/Aztec.jpg"}, {title: "Beluga", src: CFCDN+"Chatswood-Block-Out/Beluga.jpg"}, {title: "Cinnamon", src: CFCDN+"Chatswood-Block-Out/Cinnamon.jpg"}, {title: "Cyrstal", src: CFCDN+"Chatswood-Block-Out/Cyrstal.jpg"}, {title: "Fawn", src: CFCDN+"Chatswood-Block-Out/Fawn.jpg"}, {title: "Ganache", src: CFCDN+"Chatswood-Block-Out/Ganache.jpg"}, {title: "Gemstone", src: CFCDN+"Chatswood-Block-Out/Gemstone.jpg"}, {title: "Lunar", src: CFCDN+"Chatswood-Block-Out/Lunar.jpg"}, {title: "Portabello", src: CFCDN+"Chatswood-Block-Out/Portabello.jpg"}, {title: "Rice", src: CFCDN+"Chatswood-Block-Out/Rice.jpg"}, {title: "Royale", src:CFCDN+ "Chatswood-Block-Out/Royale.jpg"}, {title: "Shimmer", src: CFCDN+"Chatswood-Block-Out/Shimmer.jpg"}]
const DouBlockOut = [{title: "Aztec", src: CFCDN +"Duo-Block-Out/Aztec.jpg"}, {title: "Basalt", src: CFCDN +"Duo-Block-Out/Basalt.jpg"}, {title: "Dove", src: CFCDN +"Duo-Block-Out/Dove.jpg"}, {title: "Iron", src: CFCDN +"Duo-Block-Out/Iron.jpg"}, {title: "Nova", src: CFCDN +"Duo-Block-Out/Nova.jpg"}, {title: "Salt", src: CFCDN +"Duo-Block-Out/Salt.jpg"}, {title: "Stalla", src: CFCDN +"Duo-Block-Out/Stalla.jpg"}, {title: "Tempo", src: CFCDN +"Duo-Block-Out/Tempo.jpg"}]
const KamarBlockOut = [{title: "Cliff", src: CFCDN + "kamar-block-out/Cliff.jpg"}, {title: "Dew", src: CFCDN + "kamar-block-out/Dew.jpg"}, {title: "Frost", src: CFCDN + "kamar-block-out/Frost.jpg"}, {title: "Glade", src: CFCDN + "kamar-block-out/Glade.jpg"}, {title: "Haze", src: CFCDN + "kamar-block-out/Haze.jpg"}, {title: "Magma", src: CFCDN + "kamar-block-out/Magma.jpg"}, {title: "Moonscape", src: CFCDN + "kamar-block-out/Moonscape.jpg"}, {title: "Ocean", src: CFCDN + "kamar-block-out/Ocean.jpg"}, {title: "Petrol", src: CFCDN + "kamar-block-out/Petrol.jpg"}, {title: "Rock", src: CFCDN + "kamar-block-out/Rock.jpg"}, {title: "Sandstone", src: CFCDN + "kamar-block-out/Sandstone.jpg"}, {title: "Shell", src: CFCDN + "kamar-block-out/Shell.jpg"}]
const LereveBlockOut = [{title: "Chalk", src: CFCDN + "Lereve-Block-Out/Chalk.jpg"}, {title: "Concrete", src: CFCDN + "Lereve-Block-Out/Concrete.jpg"}, {title: "Crystal", src: CFCDN + "Lereve-Block-Out/Crystal.jpg"}, {title: "Graphite", src: CFCDN + "Lereve-Block-Out/Graphite.jpg"}, {title: "Marble", src: CFCDN + "Lereve-Block-Out/Marble.jpg"}, {title: "Mink", src: CFCDN + "Lereve-Block-Out/Mink.jpg"}, {title: "Onyx", src: CFCDN + "Lereve-Block-Out/Onyx.jpg"}, {title: "Pewter", src: CFCDN + "Lereve-Block-Out/Pewter.jpg"}, {title: "Sand", src: CFCDN + "Lereve-Block-Out/Sand.jpg"}, {title: "Shell", src: CFCDN + "Lereve-Block-Out/Shell.jpg"}]
const linesqueBlockout = [{title: "Almond",  src: CFCDN + "linesque-black-out/Almond.jpg"}, {title: "Aspen",  src: CFCDN + "linesque-black-out/Aspen.jpg"}, {title: "Blanco",  src: CFCDN + "linesque-black-out/Blanco.jpg"}, {title: "Breeze",  src: CFCDN + "linesque-black-out/Breeze.jpg"}, {title: "Denim",  src: CFCDN + "linesque-black-out/Denim.jpg"}, {title: "Dove",  src: CFCDN + "linesque-black-out/Dove.jpg"}, {title: "Fig",  src: CFCDN + "linesque-black-out/Fig.jpg"}, {title: "Fleece",  src: CFCDN + "linesque-black-out/Fleece.jpg"}, {title: "Fossil",  src: CFCDN + "linesque-black-out/Fossil.jpg"}, {title: "Raffia",  src: CFCDN + "linesque-black-out/Raffia.jpg"}, {title: "Soba",  src: CFCDN + "linesque-black-out/Soba.jpg"}, {title: "Vine",  src: CFCDN + "linesque-black-out/Vine.jpg"}]
const mantraBlockOut = [{ title: "Cotton",  src: CFCDN + "mantra-block-out/Cotton.jpg"}, { title: "Flint",  src: CFCDN + "mantra-block-out/Flint.jpg"}, { title: "Opal",  src: CFCDN + "mantra-block-out/Opal.jpg"}, { title: "Parchment",  src: CFCDN + "mantra-block-out/Parchment.jpg"}, { title: "Pebble",  src: CFCDN + "mantra-block-out/Pebble.jpg"}, { title: "Seagrass",  src: CFCDN + "mantra-block-out/Seagrass.jpg"}, { title: "Seed Pearl",  src: CFCDN + "mantra-block-out/Seed Pearl.jpg"}, { title: "Sesame",  src: CFCDN + "mantra-block-out/Sesame.jpg"}, { title: "Shale",  src: CFCDN + "mantra-block-out/Shale.jpg"}, { title: "Spice",  src: CFCDN + "mantra-block-out/Spice.jpg"}]
const palmBeachBlockout = [{ title: "Dusk", src: CFCDN + "Palm-Beach-Block-Out/Dusk.jpg"}, { title: "Gull", src: CFCDN + "Palm-Beach-Block-Out/Gull.jpg"}, { title: "Iron", src: CFCDN + "Palm-Beach-Block-Out/Iron.jpg"}, { title: "Jasmine", src: CFCDN + "Palm-Beach-Block-Out/Jasmine.jpg"}, { title: "Lyric", src: CFCDN + "Palm-Beach-Block-Out/Lyric.jpg"}, { title: "Merino", src: CFCDN + "Palm-Beach-Block-Out/Merino.jpg"}, { title: "Porpoise", src: CFCDN + "Palm-Beach-Block-Out/Porpoise.jpg"}, { title: "Quatz", src: CFCDN + "Palm-Beach-Block-Out/Quatz.jpg"}, { title: "Quill", src: CFCDN + "Palm-Beach-Block-Out/Quill.jpg"}, { title: "Summer Storm", src: CFCDN + "Palm-Beach-Block-Out/Summer Storm.jpg"}, { title: "Thunder", src: CFCDN + "Palm-Beach-Block-Out/Thunder.jpg"}, { title: "Urban", src: CFCDN + "Palm-Beach-Block-Out/Urban.jpg"}]
const skyBlockout = [{title: "Blazer", src: CFCDN + "Skye-Block-Out/Blazer.jpg"}, {title: "Chiffon", src: CFCDN + "Skye-Block-Out/Chiffon.jpg"}, {title: "Chrome", src: CFCDN + "Skye-Block-Out/Chrome.jpg"}, {title: "Earl Grey", src: CFCDN + "Skye-Block-Out/Earl_Grey.jpg"}, {title: "Oyster", src: CFCDN + "Skye-Block-Out/Oyster.jpg"}, {title: "Porcelain", src: CFCDN + "Skye-Block-Out/Porcelain.jpg"}, {title: "Raven", src: CFCDN + "Skye-Block-Out/Raven.jpg"}, {title: "Sail", src: CFCDN + "Skye-Block-Out/Sail.jpg"}, {title: "Swan", src: CFCDN + "Skye-Block-Out/Swan.jpg"}]
const dawnBO = [{title: "Beige", src: CFCDN + "Dawn/Beige.jpg"}, {title: "Bison", src: CFCDN + "Dawn/Bison.jpg"}, {title: "Caviar", src: CFCDN + "Dawn/Caviar.jpg"}, {title: "Custom Cream", src: CFCDN + "Dawn/Custom Cream.jpg"}, {title: "Earthen", src: CFCDN + "Dawn/Earthen.jpg"}, {title: "Ivory", src: CFCDN + "Dawn/Ivory.jpg"}, {title: "Macchiato", src: CFCDN + "Dawn/Machiato.jpg"}, {title: "Mid Grey", src: CFCDN + "Dawn/Mid Grey.jpg"}, {title: "Natural", src: CFCDN + "Dawn/Natural.jpg"}, {title: "Nutmeg", src: CFCDN + "Dawn/Nutmeg.jpg"}, {title: "Pewter", src: CFCDN + "Dawn/Pewter.jpg"}, {title: "Royal Blue", src: CFCDN + "Dawn/Royal Blue.jpg"}, {title: "Sesame", src: CFCDN + "Dawn/Sesame.jpg"}, {title: "Shale", src: CFCDN + "Dawn/Shale.jpg"}, {title: "Taupe", src: CFCDN + "Dawn/Taupe.jpg"}]
const sunsetBO = [{title: "Antique", src: CFCDN + "Sunset/Antique.jpg"}, {title: "Ash Grey", src: CFCDN + "Sunset/Ash Grey.jpg"}, {title: "Bark", src: CFCDN + "Sunset/Bark.jpg"}, {title: "Beaver", src: CFCDN + "Sunset/Beaver.jpg"}, {title: "Bone", src: CFCDN + "Sunset/Bone.jpg"}, {title: "Cashew", src: CFCDN + "Sunset/Cashew.jpg"}, {title: "Ecru", src: CFCDN + "Sunset/Ecru.jpg"}, {title: "Flax", src: CFCDN + "Sunset/Flax.jpg"}, {title: "Lace", src: CFCDN + "Sunset/Lace.jpg"}, {title: "Lava", src: CFCDN + "Sunset/Lava.jpg"}, {title: "Mushroom", src: CFCDN + "Sunset/Mushroom.jpg"}, {title: "Natural", src: CFCDN + "Sunset/Natural.jpg"}, {title: "Onyx", src: CFCDN + "Sunset/Onyx.jpg"}, {title: "Parchment", src: CFCDN + "Sunset/Parchment.jpg"}, {title: "Pepper", src: CFCDN + "Sunset/Pepper.jpg"}, {title: "Sahara", src: CFCDN + "Sunset/Sahara.jpg"}, {title: "Seal", src: CFCDN + "Sunset/Seal.jpg"}, {title: "Silver", src: CFCDN + "Sunset/Silver.jpg"}, {title: "Snow", src: CFCDN + "Sunset/Snow.jpg"}, {title: "Stone", src: CFCDN + "Sunset/Stone.jpg"}, {title: "Tuape", src: CFCDN + "Sunset/Tuape.jpg"}, {title: "Vanilla", src: CFCDN + "Sunset/Vanilla.jpg"}, {title: "Warm Grey", src: CFCDN + "Sunset/Warm Grey.jpg"}]
const mandalayBO = [{title: "Abalone", src: CFCDN + "Mandalay/Abalone.jpg"}, {title: "Alabaster", src: CFCDN + "Mandalay/Alabaster.jpg"}, {title: "Alpaca", src: CFCDN + "Mandalay/Alpaca.jpg"}, {title: "Cement", src: CFCDN + "Mandalay/Cement.jpg"}, {title: "Cloud", src: CFCDN + "Mandalay/Cloud.jpg"}, {title: "Donkey", src: CFCDN + "Mandalay/Donkey.jpg"}, {title: "Ivory", src: CFCDN + "Mandalay/Ivory.jpg"}, {title: "Muslin", src: CFCDN + "Mandalay/Muslin.jpg"}]
const Tapestry = [{title: "Buff", src: CFCDN + "Tapestry-BOLF/Buff.jpg"}, {title: "Cloud", src: CFCDN + "Tapestry-BOLF/Cloud.jpg"}, {title: "Concrete", src: CFCDN + "Tapestry-BOLF/Concrete.jpg"}, {title: "Dove", src: CFCDN + "Tapestry-BOLF/Dove.jpg"}, {title: "Gunmetal", src: CFCDN + "Tapestry-BOLF/Gunmetal.jpg"}, {title: "Portland", src: CFCDN + "Tapestry-BOLF/Portland.jpg"}, {title: "Seagull", src: CFCDN + "Tapestry-BOLF/Seagull.jpg"}, {title: "Tuxedo", src: CFCDN + "Tapestry-BOLF/Tuxedo.jpg"}, {title: "White Wash", src: CFCDN + "Tapestry-BOLF/White Wash.jpg"}]

// Lifht Filter Fabrics

const douLF = [{title: "Bright White", src: CFCDN + "Duo-LF/Bright White.jpg"}, {title: "Mid Grey", src: CFCDN + "Duo-LF/Mid Grey.jpg"}, {title: "Warm White", src: CFCDN + "Duo-LF/Warm White.jpg"}]
const chatsworthLF = [{title: "Caviar", src: CFCDN + "Chastworth-LF/Caviar.jpg"}, {title: "Doe", src: CFCDN + "Chastworth-LF/Doe.jpg"}, {title: "Espresso", src: CFCDN + "Chastworth-LF/Espresso.jpg"}, {title: "Glow", src: CFCDN + "Chastworth-LF/Glow.jpg"}, {title: "Halo", src: CFCDN + "Chastworth-LF/Halo.jpg"}, {title: "Icicle", src: CFCDN + "Chastworth-LF/Icicle.jpg"}, {title: "Mirage", src: CFCDN + "Chastworth-LF/Mirage.jpg"}, {title: "Nutmeg", src: CFCDN + "Chastworth-LF/Nutmeg.jpg"}, {title: "Oasis", src: CFCDN + "Chastworth-LF/Oasis.jpg"}, {title: "Oyster", src: CFCDN + "Chastworth-LF/Oyster.jpg"}, {title: "Pearl", src: CFCDN + "Chastworth-LF/Pearl.jpg"}, {title: "Walnut", src: CFCDN + "Chastworth-LF/Walnut.jpg"}]
const levereLF = [{title: "Chalk", src: CFCDN + "lereve-lightfilter/Chalk.jpg"}, {title: "Concrete", src: CFCDN + "lereve-lightfilter/Concrete.jpg"}, {title: "Crystal", src: CFCDN + "lereve-lightfilter/Crystal.jpg"}, {title: "Graphite", src: CFCDN + "lereve-lightfilter/Graphite.jpg"}, {title: "Marble", src: CFCDN + "lereve-lightfilter/Marble.jpg"}, {title: "Mink", src: CFCDN + "lereve-lightfilter/Mink.jpg"}, {title: "Onyx", src: CFCDN + "lereve-lightfilter/Onyx.jpg"}, {title: "Pewter", src: CFCDN + "lereve-lightfilter/Pewter.jpg"}, {title: "Sand", src: CFCDN + "lereve-lightfilter/Sand.jpg"}, {title: "Shell", src: CFCDN + "lereve-lightfilter/Shell.jpg"}]
const linsqueLF = [{title: "Chestnut", src: CFCDN + "Linsque-LF/Chestnut.jpg"}, {title: "Delta", src: CFCDN + "Linsque-LF/Delta.jpg"}, {title: "Granite", src: CFCDN + "Linsque-LF/Granite.jpg"}, {title: "Hazel", src: CFCDN + "Linsque-LF/Hazel.jpg"}, {title: "Levi", src: CFCDN + "Linsque-LF/Levi.jpg"}, {title: "Lily", src: CFCDN + "Linsque-LF/Lily.jpg"}, {title: "Oatcake", src: CFCDN + "Linsque-LF/Oatcake.jpg"}, {title: "Owl", src: CFCDN + "Linsque-LF/Owl.jpg"}, {title: "Stonewash", src: CFCDN + "Linsque-LF/Stonewash.jpg"}, {title: "Trellis", src: CFCDN + "Linsque-LF/Trellis.jpg"}, {title: "Wicker", src: CFCDN + "Linsque-LF/Wicker.jpg"}, {title: "Winter", src: CFCDN + "Linsque-LF/Winter.jpg"}]
const mantraLF = [{title: "Cotton", src: CFCDN + "mantra-lightfilter/Cotton.jpg"}, {title: "Parchment", src: CFCDN + "mantra-lightfilter/Parchment.jpg"}, {title: "Pebble", src: CFCDN + "mantra-lightfilter/Pebble.jpg"}, {title: "Seagrass", src: CFCDN + "mantra-lightfilter/Seagrass.jpg"}, {title: "Seed Pearl", src: CFCDN + "mantra-lightfilter/Seed Pearl.jpg"}, {title: "Sesame", src: CFCDN + "mantra-lightfilter/Sesame.jpg"}, {title: "Shale", src: CFCDN + "mantra-lightfilter/Shale.jpg"}]
const palmBeachLF = [{title: "Angora", src: CFCDN + "Palm-Beach-LF/Angora.jpg"}, {title: "Horizon", src: CFCDN + "Palm-Beach-LF/Horizon.jpg"}, {title: "Ink", src: CFCDN + "Palm-Beach-LF/Ink.jpg"}, {title: "Melody", src: CFCDN + "Palm-Beach-LF/Melody.jpg"}, {title: "Monsoon", src: CFCDN + "Palm-Beach-LF/Monsoon.jpg"}, {title: "Pearl", src: CFCDN + "Palm-Beach-LF/Pearl.jpg"}, {title: "Steel", src: CFCDN + "Palm-Beach-LF/Steel.jpg"}]
const skyeLF = [{title: "Blazer", src: CFCDN + "Skye-LF/Blazer.jpg"}, {title: "Chiffon", src: CFCDN + "Skye-LF/Chiffon.jpg"}, {title: "Chrome", src: CFCDN + "Skye-LF/Chrome.jpg"}, {title: "Earl Grey", src: CFCDN + "Skye-LF/Earl Grey.jpg"}, {title: "Oyster", src: CFCDN + "Skye-LF/Oyster.jpg"}, {title: "Porcelain", src: CFCDN + "Skye-LF/Porcelain.jpg"}, {title: "Raven", src: CFCDN + "Skye-LF/Raven.jpg"}, {title: "Sail", src: CFCDN + "Skye-LF/Sail.jpg"}, {title: "Swan", src: CFCDN + "Skye-LF/Swan.jpg"}]
const aventusSC = [{title: "Charcoal Bronze", src: CFCDN + "Aventus-SC/Charcoal Bronze.jpg"}, {title: "Charcoal Denim", src: CFCDN + "Aventus-SC/Charcoal Denim.jpg"}, {title: "Charcoal Grey", src: CFCDN + "Aventus-SC/Charcoal Grey.jpg"}, {title: "Charcoal", src: CFCDN + "Aventus-SC/Charcoal.jpg"}, {title: "Concrete", src: CFCDN + "Aventus-SC/Concrete.jpg"}, {title: "Domino", src: CFCDN + "Aventus-SC/Domino.jpg"}, {title: "Dune Grey", src: CFCDN + "Aventus-SC/Dune Grey.jpg"}, {title: "Graphite", src: CFCDN + "Aventus-SC/Graphite.jpg"}, {title: "Gull", src: CFCDN + "Aventus-SC/Gull.jpg"}, {title: "Ice", src: CFCDN + "Aventus-SC/Ice.jpg"}, {title: "Pewter", src: CFCDN + "Aventus-SC/Pewter.jpg"}, {title: "Platinum", src: CFCDN + "Aventus-SC/Platinum.jpg"}, {title: "White Grey", src: CFCDN + "Aventus-SC/White Grey.jpg"}, {title: "White Linen", src: CFCDN + "Aventus-SC/White Linen.jpg"}, {title: "White Stone", src: CFCDN + "Aventus-SC/White Stone.jpg"}, {title: "White", src: CFCDN + "Aventus-SC/White.jpg"}, {title: "Wren", src: CFCDN + "Aventus-SC/Wren.jpg"}]
export interface Fabric{
    title:string;
    src:string;
}
export interface Fabrics {
    title: string;
    id:number;
    desciption:string;
    colours:Fabric[]
    src:string;
}
export const fabricBrandBlockOut = [
    {
        title: 'Vibe Blockout ★',
        id: 1,
        desciption : "Featured PVC free acrylic coating has anti-fade, 100% blackout, easy clean and antifungal properties.",
        colours: VibeBlockout,
        src: CFCDN+"vibe-block-out/Vibe_HERO.jpg",
    },
    
    {
        title: 'Linesque Blockout ★',
        id: 6,
        desciption : "Linesque closes the gap between window blind fabric and drapery fabric.",
        colours: linesqueBlockout,
        src: CFCDN + "linesque-black-out/Linesque_HERO.jpg",
    },
    {
        title: 'Skye Blockout ★',
        id: 9,
        desciption : "Skye has a subtle texture enhanced with cationic yarn and a modern colour range. ",
        colours: skyBlockout,
        src: CFCDN + "Skye-LF/Skye_HERO_LF.jpg",
    },
    {
        title: 'Duo Blockout',
        id: 2,
        desciption : "Dou Blockout is a durable, easy-to-clean blackout fabric with a sleek, pattern-free design.",
        colours: DouBlockOut,
        src: CFCDN+"Duo-Block-Out/DuoBlock_HERO.jpg",
    },
    {
        title: 'Chatsworth Blockout',
        id: 3,
        desciption : "Chatsworth is a blackout fabric with a stylish horizontal pattern, offering complete light exclusion and modern elegance.",
        colours: ChatswoodBlockout,
        src: CFCDN+"Chatswood-Block-Out/Chastworth_HERO_BO.jpg",
    },
    {
        title: 'Karma Blockout',
        id: 4,
        desciption : "Karma fabric is renowned for its sleek, modern appearance.",
        colours: KamarBlockOut,
        src: CFCDN + "kamar-block-out/Karma_HERO_BO.jpg",
    },
    {
        title: 'Le Reve Blockout',
        id: 5,
        desciption : "Le Reve brings elegant texture to the Shaw at Home fabric collection. Suitable for wider windows, with a contemporary colour range.",
        colours: LereveBlockOut,
        src: CFCDN + "Lereve-Block-Out/Le_Reve_HERO.jpg",
    }
    ,
    {
        title: 'Mantra Blockout',
        id: 7,
        desciption : "Mantra is a striking jacquard suitable for wider windows, with a multi-tone colour range to compliment contemporary interior styles.",
        colours: mantraBlockOut,
        src: CFCDN + "mantra-block-out/Mantra_HERO.jpg",
    },
    {
        title: 'Palm Beach Blockout',
        id: 8,
        desciption : "Palm Beach is a plain weave blackout fabric, offering complete light exclusion with a simple, elegant design.",
        colours: palmBeachBlockout,
        src: CFCDN + "Palm-Beach-Block-Out/Z-ATT024.jpg",
    }
    ,
    {
        title: 'Dawn Blockout',
        id: 10,
        desciption : "",
        colours: dawnBO,
        src: CFCDN + "Dawn/DAWN-HERO-2.jpg",
    },
    {
        title: 'Sunset Blockout',
        id: 11,
        desciption : "",
        colours: sunsetBO,
        src: CFCDN + "Sunset/Sunset-HERO-2.jpeg",
    }
    ,
    {
        title: 'Mandalay Blockout',
        id: 12,
        desciption : "",
        colours: mandalayBO,
        src: CFCDN + "Mandalay/Abalone.jpg",
    }
    ,
    {
        title: 'Tapestry Blockout',
        id: 13,
        desciption : "",
        colours: Tapestry,
        src: CFCDN + "Tapestry-BOLF/Tapestry-HERO.jpg",
    }
    
]

export const fabricBrandLF = [
    {
        title: 'Linesque Light Filter ★',
        id: 4,
        desciption : "",
        colours: linsqueLF,
        src: CFCDN + "Linsque-LF/Linesque_HERO_LF (1).jpg",
    },
    {
        title: 'Skye Light Filter ★',
        id: 7,
        desciption : "",
        colours: skyeLF,
        src: CFCDN + "Skye-Block-Out/Skye_HERO_BO.jpg",
    },
    {
        title: 'Duo Light Filter',
        id: 1,
        desciption : "",
        colours: douLF,
        src: CFCDN+"Duo-LF/Bright White.jpg",
    },
    {
        title: 'Chatsworth Light Filter',
        id: 2,
        desciption : "",
        colours: chatsworthLF,
        src: CFCDN+"Chastworth-LF/Chastworth_HERO_LF.jpg",
    },
    {
        title: 'Le Reve Light Filter',
        id: 3,
        desciption : "",
        colours: levereLF,
        src: CFCDN + "lereve-lightfilter/Le_Reve_HERO_LF.jpg",
    },
    
    
    {
        title: 'Mantra Light Filter',
        id: 5,
        desciption : "",
        colours: mantraLF,
        src: CFCDN + "mantra-lightfilter/Mantra_HERO_LF.jpg",
    },
    {
        title: 'Palm Beach Light Filter',
        id: 6,
        desciption : "",
        colours: palmBeachLF,
        src: CFCDN + "Palm-Beach-LF/Z-ATT016.jpg",
    },
    
    {
        title: 'Tapestry Light Filter',
        id: 8,
        desciption : "",
        colours: Tapestry,
        src: CFCDN + "Tapestry-BOLF/Tapestry-HERO.jpg",
    }
    
]

export const fabricBrandSC = [
    {
        title: 'Aventus 3%',
        id: 1,
        desciption : "",
        colours: aventusSC,
        src: CFCDN + "Aventus-SC/Z-ATT035.jpg",
    },
    {
        title: 'Aventus 5%',
        id: 2,
        desciption : "",
        colours: aventusSC,
        src: CFCDN + "Aventus-SC/Z-ATT035.jpg",
    },
    {
        title: 'Aventus 10%',
        id: 3,
        desciption : "",
        colours: aventusSC,
        src: CFCDN + "Aventus-SC/Z-ATT035.jpg",
    }
]
export const fabricType = [
    {title:'Blockout Fabrics',src:CFCDN+'roller-blind/Blockout-Roller-Blind.png',fabrics : fabricBrandBlockOut, desc: ['Great for blocking out light', 'Provides ultimate privacy','Perfect for bedroom',]},
    {title:'Light Filtering Fabrics',src:CFCDN+'roller-blind/Light-Filter-Roller-Blind.png',fabrics : fabricBrandLF, desc: ['Diffuses and softens light','Provide daytime privacy and filter the view while maintaining light']},
    {title:'Sunscreen Fabrics',src:CFCDN+'roller-blind/Sunscreen-Roller-Blind.png',fabrics : fabricBrandSC,desc: ['Allow for daytime privacy','Block 95% of UV rays','Ideal for reducing glare and heat while maintaning the view'] },
]

export const ChainColor = [
    {title: "Stainless Steel ★",src:CFCDN+'roller-blind/RollerBlindChain/stainless-steel.png'},
    {title: "White",src:CFCDN+'roller-blind/RollerBlindChain/white.png'},
    {title: "Ivory",src:CFCDN+'roller-blind/RollerBlindChain/ivory.png'},
    {title: "Grey",src:CFCDN+'roller-blind/RollerBlindChain/grey.png'},
    {title: "Driftwood",src:CFCDN+'roller-blind/RollerBlindChain/driftwood.png'},
    {title: "Black",src:CFCDN+'roller-blind/RollerBlindChain/black.png'}
]
export const bracket = [
    {title: "Standard Bracket",src:CFCDN+'roller-blind/bracket/bracket.png'},
    {title: "Extension Bracket",src:CFCDN+'roller-blind/bracket/extension-bracket.png'},
    
]

export interface  Color {
    id: number,
    title: string,
    color: string
}
export const bottomBar = [
    {
        title: "Ovar Bar",
        src:CFCDN+'roller-blind/bottomBar/Oval-Bar.png',
        colour :[
            {id: 1, title: "Satin Black", color:"#000000"},
            {id: 7, title: "Charcoal", color:"#2b2f32"}, 
            {id: 9, title: "Storm", color:"#585e5c"}, 
            {id: 8, title: "Luxe Bronze", color:"#9a9182"}, 
            {id: 2, title: "Clear Anodised", color:"#bcc5c2"}, 
            {id: 3, title: "River Gum", color:"#f8f0e3"},
            {id: 4, title: "Shoji White", color:"#f5f6f0"},
            {id: 5, title: "White", color:"#ffffff"},
            {id: 6, title: "White Birch", color:"#fefef2"}, 
        ] },
    {   
        title: "Rectangle Silent Bar",
        src:CFCDN+'roller-blind/bottomBar/Rectangal-Silent-Bar.png',
        colour :[
                {id: 1, title: "Satin Black", color:"#000000"},
                {id: 2, title: "Clear Anodised", color:"#bcc5c2"}, 
                {id: 3, title: "River Gum", color:"#f8f0e3"},
                {id: 4, title: "Shoji White", color:"#f5f6f0"},
                {id: 5, title: "Gloss White", color:"#ffffff"},
                {id: 5, title: "White Birch", color:"#fefef2"},
        ]},
    
]

    export const bracketColors= [
   
    {id: 1, title: "White", color:"#ffffff"},
    {id: 2, title: "Ivory", color:"#e5ddc4"}, 
    {id: 3, title: "Grey", color:"#b0afa7"},
    {id: 4, title: "Black", color:"#121212"},  ] 


  
    export const controlType = [
        {title: "Manual",src:CFCDN+'roller-blind/roller-blind-chain3.png'},
        {title: "Motorise",src:CFCDN+'roller-blind/roller-blind-motor.png'}
    ]
    export const powerType = [
        {title: "Battery",src:CFCDN+'roller-blind/full-battery.png'},
        {title: "Electric",src:CFCDN+'roller-blind/power.png'}
    ]
    export const CWSelection = [
        {title: "CW 1 Channel Remote",src:CFCDN+'protecta/control/cw-1-channel_prev_ui.png'},
        {title: "CW 5 Channel Remote",src:CFCDN+'protecta/control/cw-5-channel_prev_ui.png'},
        {title: "CW 8 Channel Remote",src:CFCDN+'protecta/control/cw-8-channel_prev_ui.png'},
        {title: "CW 15 Channel Remote",src:CFCDN+'protecta/control/cw-15-channel_prev_ui.png'},
        {title: "CW 1 Channel Switch",src:CFCDN+'protecta/control/cw-switch-1_prev_ui.png'},
        {title: "CW 5 Channel Switch",src:CFCDN+'protecta/control/cw-switch-5_prev_ui.png'}
    ]
   
    export const SomfySelection = [
        {title: "Somfy 1 Channel Remote",src:CFCDN+'protecta/control/somfy-1-channel.avif'},
        {title: "Somfy 2 Channel Remote",src:CFCDN+'protecta/control/somfy-2-channel.avif'},
        {title: "Somfy 5 Channel Remote",src:CFCDN+'protecta/control/somfy-5-channel.avif'},
        {title: "Somfy 16 Channel Remote",src:CFCDN+'protecta/control/somfy-16-channel.avif'},
        {title: "Somfy 1 Channel Switch",src:CFCDN+'protecta/control/somfy-sw-1-channel.avif'},
        {title: "Somfy 2 Channel Switch",src:CFCDN+'protecta/control/somfy-sw-2-channel.avif'},
        {title: "Somfy 4 Channel Switch",src:CFCDN+'protecta/control/somfy-sw-4-channel.avif'}
    ]
    export const AlphaSelection = [
        {title: "Alpha 1 Channel Remote",src:CFCDN+'protecta/control/alpha-1-channel.jpg'},
        {title: "Alpha 2 Channel Remote",src:CFCDN+'protecta/control/alpha-2-channel.jpg'},
        {title: "Alpha 5 Channel Remote",src:CFCDN+'protecta/control/alpha-5-channel.jpg'},
        {title: "Alpha 8 Channel Remote",src:CFCDN+'protecta/control/alpha-8-channel.jpg'},
        {title: "Alpha 16 Channel Remote",src:CFCDN+'protecta/control/alpha-16-channel.jpg'},
        {title: "Alpha 1 Channel Switch",src:CFCDN+'protecta/control/alpha-sw-1-channel.jpg'},
        {title: "Alpha 2 Channel Switch",src:CFCDN+'protecta/control/alpha-sw-2-channel.jpg'},
        {title: "Alpha 8 Channel Switch",src:CFCDN+'protecta/control/alpha-switch-8-channel.jpg'}
    ]
    export const motoBrand = [
        {title: "CW",src:CFCDN+'awning-motor-brand/cw-square.jpg', controls: CWSelection},
        {title: "ALPHA",src:CFCDN+'awning-motor-brand/alpha-square.jpg', controls: AlphaSelection},
        {title: "SOMFY",src:CFCDN+'awning-motor-brand/somfy.jpg', controls: SomfySelection}
    ]
    